/* eslint-disable react/jsx-props-no-spreading */
import { ModalStateContext } from '@coop/cds-components';
import { useInitialFocus } from '@coop/hooks';
import * as React from 'react';
import { useContext } from 'react';

interface ModalHeaderProps extends React.HtmlHTMLAttributes<HTMLHeadingElement> {
    autoFocus?: boolean;
}

const ModalHeader = (props: ModalHeaderProps) => {
    const h1Ref = React.useRef<HTMLHeadingElement>(null);
    useInitialFocus(h1Ref, props.autoFocus !== false);
    return (
        // TODO: Use Heading component when moved to packages
        <ModalContextHeader ref={h1Ref} tabIndex={-1} {...props} className={props.className} />
    );
};

export const ModalContextHeader = React.forwardRef<
    HTMLHeadingElement,
    React.PropsWithChildren<ModalHeaderProps>
>(({ children, ...props }, ref) => {
    const modalContext = useContext(ModalStateContext);

    return (
        <h1 ref={ref} {...props} id={modalContext?.headerId} aria-atomic="true">
            {children}
        </h1>
    );
});

export default ModalHeader;
